import { call, delay, put, takeEvery } from "redux-saga/effects";
import HttpService from "../../HttpService/HttpService";
import { store } from "../store";
import {
  APP_ID,
  DESIGN_URI,
  LOCUS_URI,
  NOTIFICATION_SERVICE_URI,
} from "../../utilities/paths";

import { openToast } from "../../Toasts";

import axios from "axios";
import {
  ADD_NEW_QUOTE,
  AddNewQuoteAction,
  CREATE_NEW_FOLDER_FOR_AD,
  CreateNewFolderForAdOnDAM,
  DELETE_NOTICE_REQUEST,
  DELETE_QUOTE_ROW,
  DELETE_UPLOADED_FILE,
  DeleteNoticeRequestAction,
  DeleteQuoteRowAction,
  DeleteUploadedFile,
  FETCH_ALL_RAISE_AD_REQUEST,
  FetchAllRaiseAdRequestAction,
  GET_AGENCY_QUOTES_DATA,
  GET_CITIES,
  GET_FILES_BY_STAGE,
  GET_NOTICE_EMAIL_DATA,
  GET_QUOTATION_DATA,
  GET_USER_WORKSPACE_ROLE,
  GetAgencyQuotesFormDataAction,
  GetCitiesByStateAction,
  GetFilesByStageAction,
  GetNoticeEmailDataAction,
  GetQuotationDataAction,
  GetUserWorkspaceRoleAction,
  PATCH_AGENCY_QUOTES,
  PatchAgencyQuotesAction,
  POST_QUOTATION_DATA,
  PostQuotationDataAction,
  RAISE_NEW_AD_REQUEST,
  RaiseNewRequestAction,
  SEND_EMAIL,
  SendEmailAction,
  UPLOAD_REQUEST_FILE,
  UploadRequestFile,
} from "../types/raiseAdRequest";
import {
  addNewQuoteAction,
  deleteUploadedFileReducer,
  getAllRaisedRequest,
  getCitiesByStateAction,
  getNoticeEmailDataAction,
  patchAgencyQuotesAction,
  sendEmailAction,
  setAgencyQuotesFormDataAction,
  setCitiesByStateAction,
  setEmailDataAction,
  setNewQuoteRow,
  setQuotationDataAction,
  setUploadedFileForAdAgency,
  setUserWorkspaceRoleAction,
  stopLoadingOnErrorAction,
  updatehAgencyQuotesAction,
  updateLastStepKey,
} from "../actions/raiseAdRequest";
import {
  addNewQuoteAPI,
  agencyQuotesDetailsGetAPI,
  appAPI,
  deleteAgencyQuoteAPI,
  getNoticeFilesAPI,
  getRaisedAdRequestAPI,
  noticeEmailsAPI,
  patchAgencyQuotesAPI,
  raisedRequestAPI,
  raiseNewAdRequestAPI,
} from "../../MappedAPI/MappedAPI";
import { getUrlProperties } from "../../utilities/common-function";
import { StepKeysName } from "../../Pages/RaiseNoticeAdRequest/utils";
import moment from "moment";

function* fetchAllRaiseAdRequestsWorker(action: FetchAllRaiseAdRequestAction) {
  const { productId, page = 1, search = "" } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  let shouldLoading: boolean = false;
  try {
    let params = `/?workspace_id=${productId}&page=${page}`;
    if (search) {
      params += `&search=${search}`;
    }
    let { data } = yield call(
      HttpService.get,
      DESIGN_URI,
      `${getRaisedAdRequestAPI}${params}`,
      TOKEN
    );

    if (!data.error) {
      yield put(getAllRaisedRequest({ data: data.data, search, page }));
    }
  } catch (error) {
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
    // yield put(stopLoadingOnErrorAction());
  }
}

function* raiseNewAdRequestWorker(action: RaiseNewRequestAction) {
  let { payload } = action;
  const TOKEN: any = store.getState().authentication.token;
  try {
    const personDetails = store.getState().authentication;
    const requiredPayload = {
      workspace_id: payload,
      requested_by: personDetails.userData.userId,
      requested_by_name: personDetails.userData.firstName,
      stage: "Request Creation",
    };
    let { data } = yield call(
      HttpService.post,
      DESIGN_URI,
      `${raiseNewAdRequestAPI}`,
      TOKEN,
      requiredPayload
    );
    if (!data.error) {
      const urlFormed = `#/cocreate/workflow/raise-notice-ad/${payload}/request-creation/${data.data.req_id}`;
      window.location.assign(urlFormed);
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* getQuotationDataWorker(action: GetQuotationDataAction) {
  const requestId = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let params = `?req_id=${requestId}`;
    let { data } = yield call(
      HttpService.get,
      DESIGN_URI,
      `${raisedRequestAPI}${params}`,
      TOKEN
    );

    if (!data.error) {
      const { data: stateData } = yield call(
        HttpService.get,
        DESIGN_URI,
        `/api/states`,
        TOKEN
      );
      yield put(
        setQuotationDataAction({
          quotationData: data.data,
          states: stateData.data,
        })
      );
      if (!stateData.error && !!data.data.state) {
        const requiredState = stateData.data.find(
          (state) => state.name === data.data.state
        );
        yield put(getCitiesByStateAction(requiredState.id));
      }
      yield put(getNoticeEmailDataAction({ requestId, stage: 1 }));
    }
  } catch (error) {
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
    // yield put(stopLoadingOnErrorAction());
  }
}

function* postQuotationDataWorker(action: PostQuotationDataAction) {
  let {
    id,
    formData,
    stage,
    nextStepKey,
    workspaceId,
    emailFormValues,
  } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let { data } = yield call(
      HttpService.patch,
      DESIGN_URI,
      `${raisedRequestAPI}?req_id=${id}`,
      TOKEN,
      { ...formData, stage }
    );
    if (!data.error) {
      yield put(updateLastStepKey(stage));
      if(!!emailFormValues){

        yield put(
          sendEmailAction({
            formData,
            template_id: "41358139",
            stage: "1",
            emailFormValues,
          })
        );
      }
      const urlFormed = `#/cocreate/workflow/raise-notice-ad/${workspaceId}/${nextStepKey}/${id}`;
      window.location.assign(urlFormed);
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* fetchAgencyQuotesDataWorker(action: GetAgencyQuotesFormDataAction) {
  const requestId = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let params = `?request_id=${requestId}`;
    let { data } = yield call(
      HttpService.get,
      DESIGN_URI,
      `${agencyQuotesDetailsGetAPI}${params}`,
      TOKEN
    );

    if (!data.error) {
      if (!data?.data?.data?.length) {
        yield put(addNewQuoteAction(requestId));
        yield put(addNewQuoteAction(requestId));
      }
      yield put(setAgencyQuotesFormDataAction(data.data));
    }
  } catch (error) {
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
    // yield put(stopLoadingOnErrorAction());
  }
}

function* addNewAgencyQuoteWorker(action: AddNewQuoteAction) {
  let { payload } = action;
  const TOKEN: any = store.getState().authentication.token;
  try {
    const requiredPayload = {
      request: payload,
      stage: "Agency Quote Details",
    };
    let { data } = yield call(
      HttpService.post,
      DESIGN_URI,
      `${addNewQuoteAPI}`,
      TOKEN,
      requiredPayload
    );

    if (!data.error) {
      yield put(setNewQuoteRow(data.data));
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* getCitiesByStateWorker(action: GetCitiesByStateAction) {
  const stateId = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let { data } = yield call(
      HttpService.get,
      DESIGN_URI,
      `/api/cities/?state_id=${stateId}`,
      TOKEN
    );

    if (!data.error) {
      yield put(setCitiesByStateAction(data.data));
    }
  } catch (error) {
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
    // yield put(stopLoadingOnErrorAction());
  }
}

function* deleteQuoteRowWorker(action: DeleteQuoteRowAction) {
  let rowId = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    const params = `?id=${rowId}`;
    let { data } = yield call(
      HttpService.delete,
      DESIGN_URI,
      `${deleteAgencyQuoteAPI}${params}`,
      TOKEN
    );
    if (!data.error) {
      yield put(stopLoadingOnErrorAction());
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* postAgencyQuotesWorker(action: PatchAgencyQuotesAction) {
  let {
    status,
    stage,
    workspaceId,
    nextStepKey,
    id,
    folder_url,
    shouldSendMail = false,
    emailContent,
    tableHtml=""
  } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  const quoteDetails = store.getState().raiseAdRequest.quoteDetailsFormData;
  const updatedQuoteDetails = quoteDetails.data.map((row) => ({
    ...row,
    status,
  }));

  const quotePricing = quoteDetails.quote_pricing.reduce((acc, item) => {
    acc[item.key] = item.net_cost;
    return acc;
  }, {});

  const payload = {
    stage,
    quotes_data: updatedQuoteDetails,
    quotes_pricing: {
      ...quotePricing,
      request: updatedQuoteDetails[0].request,
    },
    ...(folder_url
      ? { folder_url, folder_created: true } // ✅ add both when folder_url exists
      : {}),
  };

  try {
    let { data } = yield call(
      HttpService.patch,
      DESIGN_URI,
      `${patchAgencyQuotesAPI}`,
      TOKEN,
      payload
    );
    if (!data.error) {
      if (!!workspaceId) {
        if (!!shouldSendMail) {
          yield put(
            sendEmailAction({
              formData: emailContent,
              template_id: "41412199",
              stage: "3",
              tableHtml
            })
          );
        }
        yield put(updateLastStepKey(stage));
        const urlFormed = `#/cocreate/workflow/raise-notice-ad/${workspaceId}/${nextStepKey}/${id}`;
        window.location.assign(urlFormed);
      } else {
        yield put(
          updatehAgencyQuotesAction({
            quotes_data: updatedQuoteDetails,
            status,
            stage,
          })
        );
      }
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* getNoticeEmailWorker(action: GetNoticeEmailDataAction) {
  const { requestId, stage } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let params = `?request_id=${requestId}&stage=${stage}`;
    let { data } = yield call(
      HttpService.get,
      NOTIFICATION_SERVICE_URI,
      `${noticeEmailsAPI}${params}`,
      TOKEN
    );
    if (!data.error) {
      if ((!data?.data?.to_email_ids?.length && stage !== 1) || stage === 7) {
        yield put(getNoticeEmailDataAction({ requestId, stage: 1 }));
      }
      yield put(setEmailDataAction({ data: data.data, stage }));
    }
  } catch (error) {
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
    // yield put(stopLoadingOnErrorAction());
  }
}

function* createNewAdFolderOnDamWorker(action: CreateNewFolderForAdOnDAM) {
  let {
    name,
    product_id,
    requestId,
    shouldSendMail,
    emailContent,
    tableHtml,
  } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let { data } = yield call(
      HttpService.post,
      DESIGN_URI,
      `/api/folder/new`,
      TOKEN,
      {
        name,
        product_id,
        type: "project",
      }
    );

    if (!data.error) {
      yield put(
        patchAgencyQuotesAction({
          status: "Accepted",
          stage: "Ad Release",
          nextStepKey: StepKeysName.AdRelease,
          workspaceId: product_id,
          id: requestId,
          folder_url: data?.data?.id,
          shouldSendMail,
          emailContent,
          tableHtml
        })
      );
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* deleteNoticeRequestWorker(action: DeleteNoticeRequestAction) {
  let { selectedProductId, requestId } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    const params = `?req_id=${requestId}`;
    let { data } = yield call(
      HttpService.delete,
      DESIGN_URI,
      `${raisedRequestAPI}${params}`,
      TOKEN
    );
    if (!data.error) {
      const urlFormed = `/#/cocreate/raise-notice-ad/${selectedProductId}`;
      window.location.assign(urlFormed);
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* getStageNoticeFilesWorker(action: GetFilesByStageAction) {
  const { request_id, stage } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let params = `by-stage?request_id=${request_id}&stage=${stage}`;
    let { data } = yield call(
      HttpService.get,
      DESIGN_URI,
      `${getNoticeFilesAPI}${params}`,
      TOKEN
    );
    if (!data.error) {
      yield put(setUploadedFileForAdAgency({ data: data.data.files, stage }));
    }
  } catch (error) {
    if (error?.response?.status === 404) {
      return; // exit gracefully
    }
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
    // yield put(stopLoadingOnErrorAction());
  }
}

function* uploadRequestFilesWorker(action: UploadRequestFile) {
  let {
    request_id,
    stage,
    file,
    original_filename,
    title,
    file_size,
    file_type,
    file_category,
    next_stage,
    selectedProductId,
    release_date
  } = action.payload;
  const { callback } = action;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let requiredPayload = {
      request_id,
      file,
      original_filename,
      title,
      file_category,
      file_size,
      content_type: file_type,
      file_type,
      resource_type: file_type,
      stage: file_category,
      next_stage: stage,
      release_date: release_date ?? null
    };
    let { data } = yield call(
      HttpService.post,
      DESIGN_URI,
      `${getNoticeFilesAPI}`,
      TOKEN,
      requiredPayload
    );
    if (!data.error) {
      callback && callback(data.data, false);
      // yield put(updateLastStepKey(stage));
      // const urlFormed = `#/cocreate/workflow/raise-notice-ad/${selectedProductId}/${next_stage}/${request_id}`;
      // window.location.assign(urlFormed);
    } else {
      callback && callback(data.data, true);
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* deleteUploadedFileWorker(action: DeleteUploadedFile) {
  let { id } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let { data } = yield call(
      HttpService.delete,
      DESIGN_URI,
      `${getNoticeFilesAPI}${id}`,
      TOKEN
    );
    if (!data.error) {
      yield put(deleteUploadedFileReducer(action.payload));
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* sendEmailWorker(action: SendEmailAction) {
  let {
    formData,
    template_id,
    stage,
    emailFormValues,
    s3_urls = [],
    tableHtml=""
  } = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    const {
      requestId,
      quoationApprovalFormData,
      selectedProductId,
      quoteDetailsFormData,
    } = store.getState().raiseAdRequest;
    let requiredPayload: any;
    if (stage === "1") {
      const emailsTo = !!emailFormValues.to
        ? emailFormValues.to
        : formData?.emailContent?.to;
      const emailMessages = !!emailFormValues.message
        ? emailFormValues.message
        : !!formData?.emailContent?.message
        ? formData?.emailContent?.message
        : "";
      requiredPayload = {
        emails: emailsTo
          ?.split(",")
          .map((item) => item.trim()) // remove spaces
          .filter((item) => item.length > 0), // remove empty values,
        template_id,
        request_id: requestId,
        stage,
        request_link: `${window.location.origin}#/cocreate/workflow/raise-notice-ad/${selectedProductId}/request-creation/${requestId}`,
        branch_code: formData.branch_code || quoationApprovalFormData?.branch_code,
        id: quoationApprovalFormData?.id,
        request_type: formData?.request_type || quoationApprovalFormData?.request_type,
        city: formData?.city || quoationApprovalFormData?.city,
        state: formData?.state || quoationApprovalFormData?.state,
        message: emailMessages,
        specific_requirements: "",
      };
      if (formData?.emailContent?.cc || !!emailFormValues.cc) {
        const emailCC = !!emailFormValues.cc
          ? emailFormValues.cc
          : formData?.emailContent?.cc;
        requiredPayload.cc = emailCC
          ?.split(",")
          .map((item) => item.trim()) // remove spaces
          .filter((item) => item.length > 0); // remove empty values
      }
    }

    if (stage === "3" || stage === "5" || stage === "7") {
      requiredPayload = {
        emails: formData?.emailContent?.to
          ?.split(",")
          .map((item) => item.trim()) // remove spaces
          .filter((item) => item.length > 0), // remove empty values,
        template_id,
        request_id: requestId,
        stage,
        request_link: `${window.location.origin}#/cocreate/workflow/raise-notice-ad/${selectedProductId}/marketing-approval/${requestId}`,
        branch_code: quoationApprovalFormData.branch_code,
        id: quoationApprovalFormData?.id,
        request_type: quoationApprovalFormData?.request_type,
        city: quoationApprovalFormData?.city,
        state: quoationApprovalFormData?.state,
        message: !!formData?.emailContent?.message
          ? formData?.emailContent?.message
          : "",
      };
      if (formData?.emailContent?.cc) {
        requiredPayload.cc = formData?.emailContent?.cc
          ?.split(",")
          .map((item) => item.trim()) // remove spaces
          .filter((item) => item.length > 0); // remove empty values
      }
      if (!!tableHtml) {
        requiredPayload.request_quote = tableHtml;
      }
      if (!!s3_urls.length) {
        requiredPayload.s3_urls = s3_urls;
      }
      if (stage === "5") {
        requiredPayload.specific_requirements = `${window.location.origin}#/cocreate/public/project/${quoationApprovalFormData?.folder_public_url}`;
      }
      if (stage === "7") {
        requiredPayload.specific_requirements = `${moment(quoteDetailsFormData?.data?.[0]?.release_date).format("DD-MM-YYYY")}`;
      }
    }

    let formDataPayload = new FormData();

    Object.entries(requiredPayload).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => formDataPayload.append(`${key}[]`, item));
      } else if (value !== undefined && value !== null) {
        formDataPayload.append(key, value as any);
      }
    });
    let { data } = yield call(
      HttpService.post,
      NOTIFICATION_SERVICE_URI,
      `${noticeEmailsAPI}`,
      TOKEN,
      formDataPayload
    );
        if (!data.error && stage === "7") {
      const urlFormed = `#/cocreate/raise-notice-ad/${selectedProductId}`;
      window.location.assign(urlFormed);
    }
            if (!data.error && stage === "1") {
     const urlFormed = `#/cocreate/workflow/raise-notice-ad/${selectedProductId}/agency-quote-details/${requestId}`;
      window.location.assign(urlFormed);
    }
  } catch (error) {
    // yield put(stopLoadingOnErrorAction());
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

function* getUserWorkspaceRole(action: GetUserWorkspaceRoleAction) {
  let workspaceId = action.payload;
  const TOKEN: any = store.getState().authentication.token;
  try {
    let params = `/${APP_ID}/getWorkspaceRoles/${workspaceId}?secret_token=${TOKEN}`;
    let { data } = yield call(
      HttpService.get,
      LOCUS_URI,
      `${appAPI}${params}`,
      undefined
    );
    if (!data.error) {
      yield put(setUserWorkspaceRoleAction(data.data.role));
    }
  } catch (error) {
    openToast(
      "error",
      error?.response?.data?.message || "Something Went Wrong!"
    );
  }
}

export function* raiseAdRequestWatcher() {
  yield takeEvery(FETCH_ALL_RAISE_AD_REQUEST, fetchAllRaiseAdRequestsWorker);
  yield takeEvery(RAISE_NEW_AD_REQUEST, raiseNewAdRequestWorker);
  yield takeEvery(GET_QUOTATION_DATA, getQuotationDataWorker);
  yield takeEvery(POST_QUOTATION_DATA, postQuotationDataWorker);
  yield takeEvery(GET_AGENCY_QUOTES_DATA, fetchAgencyQuotesDataWorker);
  yield takeEvery(ADD_NEW_QUOTE, addNewAgencyQuoteWorker);
  yield takeEvery(GET_CITIES, getCitiesByStateWorker);
  yield takeEvery(DELETE_QUOTE_ROW, deleteQuoteRowWorker);
  yield takeEvery(PATCH_AGENCY_QUOTES, postAgencyQuotesWorker);
  yield takeEvery(GET_NOTICE_EMAIL_DATA, getNoticeEmailWorker);
  yield takeEvery(CREATE_NEW_FOLDER_FOR_AD, createNewAdFolderOnDamWorker);
  yield takeEvery(DELETE_NOTICE_REQUEST, deleteNoticeRequestWorker);
  yield takeEvery(GET_FILES_BY_STAGE, getStageNoticeFilesWorker);
  yield takeEvery(UPLOAD_REQUEST_FILE, uploadRequestFilesWorker);
  yield takeEvery(DELETE_UPLOADED_FILE, deleteUploadedFileWorker);
  yield takeEvery(SEND_EMAIL, sendEmailWorker);
  yield takeEvery(GET_USER_WORKSPACE_ROLE, getUserWorkspaceRole);
}
